import { createSelector, createSlice } from '@reduxjs/toolkit';

export const initialState = {
  groups: [],
  groupsAreLoading: false,
  selectedGroup: null,
  selectedGroupId: null,
  selectedGroupIsDirty: false,
  selectedGroupIsLoading: false,
  selectedGroupIsOpen: false,
  publishGroupModalOpen: false,

  // Fields
  fieldsAreDirty: false,

  // Shapes
  selectedShapes: [],
  newShapeName: '',
  creatingNewShape: false,
  selectedCustomShape: null,
  customShapes: null,
  showCustomShapes: true,
  showPasteGeosModal: false,
  copyShapesModalOpen: false,

  // field values
  showFieldValueGrid: true,
};

const slice = createSlice({
  name: 'assumptionGroupsSlice',
  initialState,
  reducers: {
    // groups
    setGroups: (state, action) => {
      state.groups = action.payload;
    },
    setGroupsAreLoading: (state, action) => {
      state.groupsAreLoading = action.payload;
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroup = action.payload;
    },
    setSelectedGroupIsLoading: (state, action) => {
      state.selectedGroupIsLoading = action.payload;
    },
    setSelectedGroupIsOpen: (state, action) => {
      state.selectedGroupIsOpen = action.payload;
    },
    setSelectedGroupIsDirty: (state, action) => {
      state.selectedGroupIsDirty = action.payload;
    },
    setSelectedGroupId: {
      reducer: (state, action) => {
        state.selectedGroupId = action.payload.selectedGroupId;
      },
      prepare: (selectedGroupId, selectedCustomShapeId) => ({
        payload: { selectedGroupId, selectedCustomShapeId },
      }),
    },
    updateGroupShape: {
      reducer: (state, action) => {
        const index = state.selectedGroup.shapes.findIndex(
          (s) => s.shapeId === action.payload.updatedShape.shapeId
        );

        state.selectedGroup.shapes[index] = action.payload.updatedShape;
      },
      prepare: (updatedShape) => ({
        payload: { updatedShape },
      }),
    },
    setPublishGroupModalOpen: (state, action) => {
      state.publishGroupModalOpen = action.payload;
    },

    // Shapes
    setSelectedShapes: (state, action) => {
      state.selectedShapes = action.payload;
    },
    setNewShapeName: (state, action) => {
      state.newShapeName = action.payload;
    },
    setSelectedCustomShape: (state, action) => {
      if (state.customShapes) {
        const index = state.customShapes.findIndex(
          (s) => s.shapeId === action.payload
        );
        state.selectedCustomShape = state.customShapes[index];
      }
    },
    setCustomShapes: (state, action) => {
      state.customShapes = action.payload;
    },
    setCreatingNewShape: (state, action) => {
      state.creatingNewShape = action.payload;
    },
    setShowCustomShapes: (state, action) => {
      state.showCustomShapes = action.payload;
    },
    setShowPasteGeosModal: (state, action) => {
      state.showPasteGeosModal = action.payload;
    },
    setCopyShapesModalOpen: (state, action) => {
      state.copyShapesModalOpen = action.payload;
    },

    //Fields
    setFieldsAreDirty: (state, action) => {
      state.fieldsAreDirty = action.payload;
    },

    // Field Values
    setShowFieldValueGrid: (state, action) => {
      state.showFieldValueGrid = action.payload;
    },

    // Sagas
    fetchAssumptionGroups: () => {},
    createAssumptionGroup: () => {},
    updateAssumptionGroup: () => {},
    publishAssumptionGroup: () => {},
    copyAssumptionGroup: () => {},
    deleteAssumptionGroup: () => {},

    fetchCustomShapes: () => {},
    createShape: () => {},
    deleteShape: () => {},
    updateShape: () => {},
    updateFieldValues: {
      reducer: () => {},
      prepare: (updatedShapes, callback) => ({
        payload: { updatedShapes, callback }
      })
    },
    fetchCustomShapesForCopy: {
      reducer: () => {},
      prepare: (groupId, callback) => ({
        payload: { groupId, callback }
      })
    },
    copyShapesForGroup: () => {},
  },
});

export const assumptionGroupsActions = slice.actions;
export default slice.reducer;

export const assumptionGroupsSelectors = {
  selectedGroupSelector: createSelector(
    (state) => state.assumptionGroupsState.selectedGroup,
    (selectedGroup) => selectedGroup
  ),
  customShapesSelector: createSelector(
    (state) => state.assumptionGroupsState.customShapes,
    (customShapes) => customShapes
  ),
  selectedCustomShapeSelector: createSelector(
    (state) => state.selectedCustomShape,
    (selectedCustomShape) => selectedCustomShape
  ),
};
